namespace GeniuzPOS.Lookups {
    export namespace VwArticleService {
        export const baseUrl = 'Lookups/VwArticle';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwArticleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwArticleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwArticle/Retrieve",
            List = "Lookups/VwArticle/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwArticleService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
